/**
 * Flat VideoBonus rows → month groups by reachedMillionAt (= bonus date), DESC.
 */
function monthKey (iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '0000-00';
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

function monthLabel (iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('ru-RU', { month: 'short', year: '2-digit' });
}

export function groupBonusesByMonth (bonuses) {
  const flat = bonuses ?? [];
  const sorted = [...flat].sort((a, b) => new Date(b.reachedMillionAt) - new Date(a.reachedMillionAt));
  const byKey = new Map();
  const groups = [];
  for (const b of sorted) {
    const key = monthKey(b.reachedMillionAt);
    if (!byKey.has(key)) {
      const g = { month: key, label: monthLabel(b.reachedMillionAt), bonuses: [] };
      byKey.set(key, g);
      groups.push(g);
    }
    byKey.get(key).bonuses.push({
      id: b.id,
      postUrl: b.postUrl,
      platform: b.platform,
      handle: b.account?.handle,
      postViews: b.postViews,
      publishedAt: b.publishedAt,
      reachedMillionAt: b.reachedMillionAt,
      paid: Boolean(b.paidAt),
      rejectedAt: b.rejectedAt,
      rejectedByUserId: b.rejectedByUserId,
      rejectionReason: b.rejectionReason,
      actions: b.actions,
    });
  }
  return groups;
}
